<div class="container">
   <form [formGroup]="shopForm">
      <div class="is-horizontal">
      <div class="field has-addons mb-2">
         <p class="control">
            <span class="select is-small">
               <select formControlName="shop">
                  <option value="">Mağaza seçin</option>
                  <option *ngFor="let shop of shops; let j = index" [value]="shop.code">{{ shop.name }}</option>
               </select>
            </span>
         </p>
         <p class="control">
            <span class="select is-small">
               <select formControlName="operation">
                  <option value="">İşlem seçin</option>
                  <option *ngFor="let operation of operations; let i = index" [value]="operation.code">{{ operation.name }}</option>
               </select>
            </span>
         </p>
         <p class="control">
            <input class="input is-small" type="text" placeholder="Sipariş kodu" formControlName="orderCode" />
         </p>
         <p class="control" *ngIf="shopForm.status === 'VALID'">
            <input
               class="input is-focused is-small"
               type="text"
               placeholder="Kod / Barkod"
               autofocus
               [formControl]="searchField"
               
            />
         </p>
      </div>
      <!-- <div class="field "></div> -->
      <!-- <p>{{shopForm.value |json}} </p> -->
   </div>
   </form>




   <article class="media" *ngFor="let item of searchItems$ | async">
      <div class="media-left">
         <nav class="level is-mobile">
            <div class="level-left">
               <a class="level-item">
                  <span class="icon is-small"><i class="fas fa-reply"></i></span>
               </a>
               <br />
               <a class="level-item">
                  <span class="icon is-small"><i class="fas fa-retweet"></i></span>
               </a>
               <br />
               <a class="level-item">
                  <span class="icon is-small"><i class="fas fa-heart"></i></span>
               </a>
            </div>
         </nav>
      </div>

      <div class="media-content">
         <div class="content">
            <h5 class="is-size-6">{{ item.code }} {{ item.name | slice: 0:50 }}</h5>
            <div class="columns">
               <div class="column is-4">
                  <p class="is-size-6">
                     {{ item.barcode }}
                     <br />
                     {{ item.brand }} / {{ item.series }}
                     <br />
                     {{ item.cat }} / {{ item.subcat }}
                  </p>
               </div>
               <div class="column is-4 has-text-weight-bold">
                  <p class="is-size-6">
                     Fiyat: {{ item.sprice | number: '1.2-2' }} {{ item.scurr }}
                     <br />
                     KDV: {{ item.tax | number: '1.2-2' }}
                     <br />
                     Stok: {{ item.stock }}
                  </p>
               </div>
            </div>
         </div>
      </div>

      <figure class="media-right">
         <p class="image is-128x128">
            <img [src]="item.imgUrl" />
         </p>
      </figure>
   </article>
</div>
